import { render } from "./warning.vue?vue&type=template&id=3fe77447"
import script from "./warning.vue?vue&type=script&lang=js"
export * from "./warning.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__